import { render, staticRenderFns } from "./Mensajes.vue?vue&type=template&id=5bce9516&scoped=true&"
import script from "./Mensajes.vue?vue&type=script&lang=js&"
export * from "./Mensajes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce9516",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Mensajes.vue
// module id = 580
// module chunks = 0